module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note10 Aura White.1fd2482d.png";